(function () {
    'use strict';

    angular
        .module('app.shell')
        .directive('edFooter', edFooter);

    function edFooter() {
        var directive = {
            // controller: ['$scope', '$rootScope', '$state', controller],
            templateUrl: '/app/content/footer/edFooter.html',
            // restrict: 'EA',
            // scope: {
            //     language: '@language'
            // }
        };
        return directive;

        // function controller($scope, $rootScope, $state) {
        //     $scope.lang = $rootScope.lang;

        // }
    }

})();